module.exports = __webpack_public_path__ + "img/about_title copy.ab64af2.png";